import { render } from "./Slice.vue?vue&type=template&id=81172114&scoped=true"
import script from "./Slice.vue?vue&type=script&lang=js"
export * from "./Slice.vue?vue&type=script&lang=js"

import "./Slice.vue?vue&type=style&index=0&id=81172114&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81172114"],['__file',"src/js/components/Slice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81172114"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81172114', __exports__)) {
    api.reload('81172114', __exports__)
  }
  
  module.hot.accept("./Slice.vue?vue&type=template&id=81172114&scoped=true", () => {
    api.rerender('81172114', render)
  })

}


export default __exports__